import { Client } from "./client";
import { PartResponse, GetAllPartsResponse, CreatePartRequest, UpdatePartRequest, CreatePartFromTemplateRequest } from "@/backend/express/controllers/partController";
import { FusaReply } from "@/types/replyTypes";
import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { FusaToastType } from "@/frontend/toasts/types";
import { I18n } from "@/i18n/I18n";

export class PartFrontendController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  getAllPartsByProject(projectId: string): Promise<GetAllPartsResponse> {
    return this.client.read(`/api/parts?projectId=${projectId}`);
  }

  getPart(id: string): Promise<PartResponse> {
    return this.client.read(`/api/parts/${id}`);
  }

  async createPart(data: CreatePartRequest): Promise<PartResponse> {
    const response = await this.client.create('/api/parts', data);
    
    if (response.status === 201 && response.part) {
      useGlobalStore.getState().addToast({
        type: FusaToastType.SUCCESS,
        message: I18n.get('modelCreated', { model: I18n.get('part'), title: response.part.title }),
        header: I18n.get('success'),
        autohide: true
      });
    }
    
    return response;
  }

  updatePart(id: string, data: UpdatePartRequest): Promise<PartResponse> {
    return this.client.update(`/api/parts/${id}`, data);
  }

  async deletePart(id: string): Promise<FusaReply> {
    const response = await this.client.delete(`/api/parts/${id}`);
    
    if (response.status === 200) {
      useGlobalStore.getState().addToast({
        type: FusaToastType.SUCCESS,
        message: I18n.get('modelRemoved', { model: I18n.get('part') }),
        header: I18n.get('success'),
        autohide: true
      });
    }
    
    return response;
  }

  async createPartFromTemplate(data: CreatePartFromTemplateRequest): Promise<PartResponse> {
    const response = await this.client.create('/api/parts/from-template', data);
    
    if (response.status === 201 && response.part) {
      useGlobalStore.getState().addToast({
        type: FusaToastType.SUCCESS,
        message: I18n.get('modelCreated', { model: I18n.get('part'), title: response.part.title }),
        header: I18n.get('success'),
        autohide: true
      });
    }
    
    return response;
  }
}
